<template>
    <div ref="root" class="feedback-menu" :class="[$mq, { 'is-open': isOpen }]">
        <button type="button" class="feedback-menu__trigger" :aria-label="$t('andy_agents.feedback.rate_response')" :aria-expanded="isOpen ? 'true' : 'false'" aria-haspopup="menu" :aria-controls="isOpen ? menuId : null" @click="toggle">
            <i class="i-andy-more i-andy-s" aria-hidden="true"></i>
        </button>
        <div v-if="isOpen" :id="menuId" ref="menu" class="feedback-menu__panel" role="menu">
            <button type="button" class="feedback-menu__option" role="menuitem" @click="choose('useful')">
                <i class="i-andy-done i-andy-s" aria-hidden="true"></i>
                <span>{{ $t('andy_agents.feedback.useful') }}</span>
            </button>
            <button type="button" class="feedback-menu__option" role="menuitem" @click="choose('not_useful')">
                <i class="i-andy-close i-andy-s" aria-hidden="true"></i>
                <span>{{ $t('andy_agents.feedback.not_useful') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
let feedbackMenuSequence = 0

export default {
    name: 'FeedbackMenu',
    data() {
        feedbackMenuSequence += 1
        return {
            isOpen: false,
            menuId: 'andy-agents-feedback-' + feedbackMenuSequence
        }
    },
    watch: {
        isOpen(isMenuOpen) {
            if (!isMenuOpen) {
                this.removeListeners()
                return
            }

            this.$nextTick(() => {
                if (!this.isOpen) {
                    return
                }
                this.addListeners()
                this.revealMenu()
            })
        }
    },
    created() {
        this.listening = false
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen
        },
        choose(feedback) {
            this.isOpen = false
            this.$emit('rate', feedback)
        },
        revealMenu() {
            const menu = this.$refs.menu
            if (!menu || typeof menu.scrollIntoView !== 'function') {
                return
            }
            menu.scrollIntoView({ block: 'nearest' })
        },
        addListeners() {
            if (this.listening) {
                return
            }
            this.listening = true
            document.addEventListener('click', this.onDocumentClick)
            document.addEventListener('keydown', this.onKeydown)
        },
        removeListeners() {
            if (!this.listening) {
                return
            }
            this.listening = false
            document.removeEventListener('click', this.onDocumentClick)
            document.removeEventListener('keydown', this.onKeydown)
        },
        onDocumentClick(event) {
            const root = this.$refs.root
            if (!this.isOpen || (root && root.contains(event.target))) {
                return
            }
            this.isOpen = false
        },
        onKeydown(event) {
            if (event.key !== 'Escape') {
                return
            }
            this.isOpen = false
        }
    }
}
</script>

<style lang="scss" scoped>
.feedback-menu {
    @include display-flex();
    @include flex-direction(column);
    @include align-items(flex-end);
    position: relative;
    align-self: flex-end;
}

.feedback-menu__trigger {
    @include display-flex();
    @include align-items(center);
    @include justify-content(center);
    @include border-radius(rem(4px));
    flex-shrink: 0;
    width: rem(36px);
    height: rem(36px);
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    color: $color-secondary-500;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:focus,
    &:active {
        outline: none;
    }
}

.feedback-menu.portrait .feedback-menu__trigger {
    width: rem(44px);
    height: rem(44px);
}

.feedback-menu__panel {
    @include display-flex();
    @include flex-direction(column);
    @include border-radius(rem(8px));
    @include box-shadow(0, rem(4px), rem(12px), 0, rgba($color-black, 0.08));
    padding: rem(4px);
    background-color: $color-white;
    border: rem(1px) solid $color-neutral-300;
    min-width: rem(172px);
}

.feedback-menu__option {
    @include display-flex();
    @include align-items(center);
    @include border-radius(rem(4px));
    @include font-size(s);
    gap: rem(8px);
    min-height: rem(36px);
    margin: 0;
    padding: rem(8px) rem(12px);
    border: 0;
    background-color: transparent;
    font-family: $text;
    line-height: rem(20px);
    color: $color-black;
    white-space: nowrap;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:focus,
    &:active {
        outline: none;
    }

    @media (hover: hover) {
        &:hover {
            background-color: $main-t90-app;
        }
    }
}

.feedback-menu.portrait .feedback-menu__option {
    min-height: rem(44px);
}
</style>
